import { V1_RECEIVE_ERRORS } from '../../actions/errors/v1receiveErrors'
import { V1_RESET_ERRORS } from '../../actions/errors/v1resetErrors'

export const initialState = {
  errors: [],
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case V1_RECEIVE_ERRORS:
      return {
        ...state,
        errors: action.errors,
      }

    case V1_RESET_ERRORS:
      return {
        ...state,
        errors: [],
      }

    default:
      return state
  }
}
